import { createAction } from 'redux-actions'
import { Notification } from 'types/notifications'

export const NOTIFICATIONS_UPDATE_SUCCESS = 'NOTIFICATIONS_UPDATE_SUCCESS'
export const notificationsUpdateSuccess = createAction<Notification[]>(NOTIFICATIONS_UPDATE_SUCCESS)
